const setPlayerReady = (ready) => {
	return {
		type: 'SET_PLAYER_READY',
		playerReady: ready,
	};
};

const setIsPlaying = (isPlaying) => {
	return {
		type: 'SET_IS_PLAYING',
		isPlaying: isPlaying,
	};
};

const setPlayerCurrentPosition = (currentPosition) => {
	return {
		type: 'SET_PLAYER_CURRENT_POSITION',
		currentPosition: currentPosition,
	};
};

const setPlayerDuration = (duration) => {
	return {
		type: 'SET_PLAYER_DURATION',
		duration: duration,
	};
};

const setMediaWithDuration = (mediaDurations) => {
	return {
		type: 'SET_MEDIA_WITH_DURATION',
		mediaDurations: mediaDurations,
	};
};

const setCurrentVolumeLevel = (currentVolumeLevel) => {
	return {
		type: 'SET_CURRENT_VOLUME_LEVEL',
		currentVolumeLevel: currentVolumeLevel,
	};
};

const setShowBackgroundElements = (showBackgroundElements) => {
	return {
		type: 'SET_SHOW_BACKGROUND_ELEMENTS',
		showBackgroundElements: showBackgroundElements,
	};
};

const setCurrentInteractiveElement = (currentInteractiveElement) => {
	return {
		type: 'SET_CURRENT_INTERACTIVE_ELEMENT',
		currentInteractiveElement: currentInteractiveElement,
	};
};

const setCurrentSceneWidgets = (currentSceneWidgets) => ({
	type: 'SET_CURRENT_SCENE_WIDGETS',
	currentSceneWidgets: currentSceneWidgets,
});

const setAnalyticsSent = (analyticsSent) => {
	return {
		type: 'SET_ANALYTICS_SENT',
		analyticsSent: analyticsSent,
	};
};

const setShowShoppingCart = (showShoppingCart) => {
	return {
		type: 'SET_SHOW_SHOPPING_CART',
		showShoppingCart: showShoppingCart,
	};
};

const setShowChatWindow = (showChatWindow) => {
	return {
		type: 'SET_SHOW_CHAT_WINDOW',
		showChatWindow: showChatWindow,
	};
};

const setReactionId = (reactionId) => {
	return {
		type: 'SET_REACTION_ID',
		reactionId: reactionId,
	};
};

const setPollsData = (polls) => {
	return {
		type: 'SET_POLL_DATA',
		polls: polls,
	};
};

const setRemovePoster = (value = true) => {
	return {
		type: 'SET_REMOVE_POSTER',
		isPosterRemoved: value,
	};
};

const setIsLiveStarted = (value = true) => {
	return {
		type: 'SET_IS_LIVE_STARTED',
		isLiveStarted: value,
	};
};

const setIsLiveStopped = (value = true) => {
	return {
		type: 'SET_IS_LIVE_STOPPED',
		isLiveStopped: value,
	};
};

const setQnAData = (qnas) => {
	return {
		type: 'SET_QNA_DATA',
		qnas: qnas,
	};
};

const setQuestionsData = (questions) => {
	return {
		type: 'SET_QUESTIONS_DATA',
		questions: questions,
	};
};

const setAdsPlaying = (adsPlaying) => {
	return {
		type: 'ADS_PLAYING',
		adsPlaying,
	};
};

export {
	setAdsPlaying,
	setQuestionsData,
	setQnAData,
	setPollsData,
	setPlayerReady,
	setPlayerCurrentPosition,
	setPlayerDuration,
	setShowBackgroundElements,
	setCurrentInteractiveElement,
	setCurrentVolumeLevel,
	setAnalyticsSent,
	setIsPlaying,
	setShowShoppingCart,
	setShowChatWindow,
	setReactionId,
	setCurrentSceneWidgets,
	setMediaWithDuration,
	setRemovePoster,
	setIsLiveStarted,
	setIsLiveStopped,
};
